<template>
    <section class="grid-products-wrap clearfix">
        <div class="container">
            <div class="tab-products-header clearfix">
                <ul class="tabs float-left">
                    <li
                        v-for="(tab, index) in tabs"
                        :key="index"
                        :class="classes(tab)"
                        @click="change(tab)"
                    >
                        {{ tab.label }}
                    </li>
                </ul>
            </div>

            <div class="tab-content grid-products">
                <div id="laptop_view" v-for="(productChunks, index) in $chunk(products, 12)" :key="index" class="grid-products-inner" v-if="isDesktop">
                    <ProductCard v-for="product in productChunks" :key="product.id" :product="product" :authenticated="authenticated"/>
                </div>
                <div id="carouselExampleControls" class="carousel slide" data-ride="carousel" v-else>
                    <div class="carousel-inner grid-products-inner">
                        <div v-for="(product, index) in products" :key="index" class="carousel-item" :class="{ 'active': index === 0 }">
                            <ProductCard :product="product" :authenticated="authenticated"/>
                        </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>

            <dynamic-tab
                v-for="(tabLabel, index) in data"
                :key="index"
                :label="tabLabel"
                :url="route('storefront.product_grid.index', { tabNumber: index + 1 })"
            >
            </dynamic-tab>
        </div>
    </section>
</template>

<script>
    import ProductCard from '../ProductCard.vue';
    import DynamicTabsMixin from '../../mixins/DynamicTabsMixin';
    import { slickPrevArrow, slickNextArrow } from '../../functions';

    export default {
        components: { ProductCard },

        mixins: [
            DynamicTabsMixin,
        ],
        data() {
            return {
                windowWidth: window.innerWidth,
            };
        },
        computed: {
            isDesktop() {
                return this.windowWidth >= 992;
            },
        },
        watch: {
            windowWidth(newWidth) {
            // This function will be called whenever windowWidth changes
            // You can perform actions based on the new window width here
            // alert('Window width changed: ' + newWidth);
                console.log('Window width changed:', newWidth);
                this.$forceUpdate();
            },
        },
        mounted() {
            // Add an event listener to watch for window resize
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            // Remove the event listener when the component is destroyed
            window.removeEventListener('resize', this.handleResize);
        },
        props: ['data','authenticated'],

        methods: {
            selector() {
                return $('.grid-products');
            },
            handleResize() {
                // Trigger a change in windowWidth when the window is resized
                this.windowWidth = window.innerWidth;
                console.log('Window width changed:', this.windowWidth);
                console.log('isDesktop:', this.isDesktop);
            },
            slickOptions() {
                return {
                    rows: 0,
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rtl: window.FleetCart.rtl,
                    prevArrow: slickPrevArrow(),
                    nextArrow: slickNextArrow(),
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                dots: true,
                                arrows: false,
                            },
                        },
                    ],
                };
            },
        },
    };
</script>
